var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.327 8.994C7.327 6.236 9.42 4 12 4s4.673 2.236 4.673 4.994c0 2.137-1.257 3.959-3.024 4.672l-1.636 2.293-1.643-2.284c-1.777-.707-3.043-2.536-3.043-4.68zm13.423 8.312c.688 0 1.25.606 1.25 1.347 0 .74-.562 1.347-1.25 1.347h-4.764v-2.694h4.764zM9.306 20v-2.694h5.432V20H9.306zM7.69 17.47V20H3.174C2.528 20 2 19.43 2 18.735c0-.696.528-1.266 1.174-1.266H7.69z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.df42254ff5e97b6b60df2bfb421ed1a1.svg";
export { ForwardRef as ReactComponent };